/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
import { put, takeLatest, call, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { push } from 'react-router-redux';
import { uniq } from 'lodash';
import moment from 'moment';
import queryString from 'querystring';
import { setNotification, getAccess } from 'utils';
import CONFIG from 'utils/config';
import * as LayoutTypes from '../types/layoutTypes';
import * as LayoutApi from '../api/layoutApi';
import { getPartnersApi } from '../api/partnerApi';
import { getResellersApi } from '../api/resellerApi';
import { getCustomersApi } from '../api/customerApi';
import { getOrderApi } from '../api/orderApi';
import { resetFormVersionsFilters } from '../actions/formVersionActions';
import { resetJobFilters } from '../actions/jobActions';
import * as LayoutActions from '../actions/layoutActions';

const getLayout = state => state.layout;

// L O A D   R E S E L L E R
function* loadResellerSaga(action) {
    try {
        const headers = {
            Authorization: '',
        };

        if (process.env.REACT_APP_ENVIRONMENT === 'local') {
            const params = {
                filter: JSON.stringify({ id: process.env.REACT_APP_ADMIN }),
            };
            const result = yield LayoutApi.getResellerApi(params, headers);
            yield put(LayoutActions.loadResellerRes(result.data));
        } else {
            const params = {
                filter: JSON.stringify({ domain: action.urlHostname }),
            };
            const result = yield LayoutApi.getResellerApi(params, headers);
            yield put(LayoutActions.loadResellerRes(result.data));
        }
    } catch (e) {
        yield put(LayoutActions.loadResellerErr());
        console.log(e);
    }
}

export function* loadLayoutResellerWatcher() {
    yield takeLatest(LayoutTypes.LOAD_RESELLER, loadResellerSaga);
}
// L O A D   R E S E L L E R


// E D I T   R E S E L L E R
function* refreshReseller() {
    const layout = yield select(getLayout);
    const { locale, reseller } = layout;
    const resellerID = reseller.data.hits[0].id;

    try {
        const params = {
            filter: JSON.stringify({ id: resellerID }),
        };

        const result = yield LayoutApi.getResellerApi(params);

        if (result.status === 200) {
            yield put(LayoutActions.loadResellerRes(result.data));
            setNotification('success', locale, 'global.success', 'profile.notification.editProfileSuccess');
        }
    } catch (e) {
        yield put(LayoutActions.loadResellerErr());
        setNotification('error', locale, 'global.error', 'profile.notification.editProfileError');
    }
}

function* editResellerProfileSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield LayoutApi.editResellerApi(action.data);

        if (result.status === 202) {
            yield call(refreshReseller);
            yield call(delay, 500);
            yield put(LayoutActions.editResellerProfileRes(result.data));
        } else {
            setNotification('error', locale, 'global.error', 'profile.notification.editProfileError');
            yield put(LayoutActions.editResellerProfileErr());
        }
    } catch (e) {
        yield put(LayoutActions.editResellerProfileErr());
        setNotification('error', locale, 'global.error', 'profile.notification.editProfileError');
        console.log(e);
    }
}

export function* editResellerProfileWatcher() {
    yield takeLatest(LayoutTypes.EDIT_RESELLER_PROFILE, editResellerProfileSaga);
}
// E D I T   R E S E L L E R

// E D I T   R E S E L L E R   P H O T O
function* editResellerPhotoSaga(action) {
    const layout = yield select(getLayout);
    const { locale, userToken } = layout;
    try {
        const headers = {
            Authorization: `${userToken.data.token_type} ${userToken.data.access_token}`,
        };

        const result = yield LayoutApi.editResellerPhotoIconApi(action.data, headers);

        if (result.status === 202) {
            yield put(LayoutActions.editResellerPhotoRes(result.data));
            yield call(delay, 500);
            yield call(refreshReseller);
        } else if (result.status === 413) {
            setNotification('error', locale, 'global.error', 'profile.notification.editProfileError');
        }
    } catch (e) {
        yield put(LayoutActions.editResellerPhotoErr());
        setNotification('error', locale, 'global.error', 'profile.notification.editProfileError');
        console.log(e);
    }
}

export function* editResellerPhotoWatcher() {
    yield takeLatest(LayoutTypes.EDIT_RESELLER_PHOTO, editResellerPhotoSaga);
}
// E D I T   R E S E L L E R   P H O T O

// E D I T   R E S E L L E R   F A V I C O N
function* editResellerFaviconSaga(action) {
    const layout = yield select(getLayout);
    const { locale, userToken } = layout;
    try {
        const headers = {
            Authorization: `${userToken.data.token_type} ${userToken.data.access_token}`,
        };

        const result = yield LayoutApi.editResellerPhotoIconApi(action.data, headers);

        if (result.status === 202) {
            yield put(LayoutActions.editResellerFaviconRes(result.data));
            yield call(delay, 500);
            yield call(refreshReseller);
        } else if (result.status === 413) {
            setNotification('error', locale, 'global.error', 'profile.notification.editProfileError');
        }
    } catch (e) {
        yield put(LayoutActions.editResellerFaviconErr());
        setNotification('error', locale, 'global.error', 'profile.notification.editProfileError');
        console.log(e);
    }
}

export function* editResellerFaviconWatcher() {
    yield takeLatest(LayoutTypes.EDIT_RESELLER_FAVICON, editResellerFaviconSaga);
}
// E D I T   R E S E L L E R   F A V I C O N

// E D I T   P R O F I L E
function* refreshUserDataSaga() {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield LayoutApi.userDataApi({});

        if (result.status === 200) {
            yield put(LayoutActions.refrechUserDataRes(result.data));
            setNotification('success', locale, 'global.success', 'profile.notification.editProfileSuccess');
        } else {
            setNotification('error', locale, 'global.error', 'profile.notification.editProfileError');
            yield put(LayoutActions.refrechUserDataErr());
        }
    } catch (e) {
        yield put(LayoutActions.refrechUserDataErr());
        setNotification('error', locale, 'global.error', 'profile.notification.editProfileError');
        console.log(e);
    }
}

function* editProfileSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield LayoutApi.editProfileApi(action.data);

        if (result.status === 202) {
            yield put(LayoutActions.editProfileRes(result.data));
            yield call(delay, 500);
            yield call(refreshUserDataSaga);
        } else {
            setNotification('error', locale, 'global.error', 'profile.notification.editProfileError');
        }
    } catch (e) {
        yield put(LayoutActions.editProfileErr());
        setNotification('error', locale, 'global.error', 'profile.notification.editProfileError');
        console.log(e);
    }
}

export function* editProfileWatcher() {
    yield takeLatest(LayoutTypes.EDIT_PROFILE, editProfileSaga);
}
// E D I T   P R O F I L E


// E D I T   P R O F I L E   P H O T O
function* editProfilePhotoSaga(action) {
    const layout = yield select(getLayout);
    const { locale, userToken } = layout;

    try {
        const headers = {
            Authorization: `${userToken.data.token_type} ${userToken.data.access_token}`,
        };
        const result = yield LayoutApi.editProfilePhotoApi(action.data, headers);

        if (result.status === 202) {
            yield put(LayoutActions.editProfilePhotoRes(result.data));
            yield call(delay, 500);
            yield call(refreshUserDataSaga);
        } else if (result.status === 413) {
            setNotification('error', locale, 'global.error', 'profile.notification.editProfileError');
        }
    } catch (e) {
        yield put(LayoutActions.editProfilePhotoErr());
        setNotification('error', locale, 'global.error', 'profile.notification.editProfileError');
        console.log(e);
    }
}

export function* editProfilePhotoWatcher() {
    yield takeLatest(LayoutTypes.EDIT_PROFILE_PHOTO, editProfilePhotoSaga);
}
// E D I T   P R O F I L E   P H O T O


// L O A D   P A R T N E R S
export function* loadPartnersLayoutSaga() {
    try {
        const params = {
            offset: 0,
            limit: 9999,
        };

        const result = yield getPartnersApi(params);
        yield put(LayoutActions.loadPartnersLayoutRes(result.data));
    } catch (e) {
        yield put(LayoutActions.loadPartnersLayoutErr());
        console.log(e);
    }
}

export function* loadPartnersLayoutWatcher() {
    yield takeLatest(LayoutTypes.LOAD_PARTNERS_LAYOUT, loadPartnersLayoutSaga);
}
// L O A D   P A R T N E R S


// L O A D   R E S E L L E R S
export function* loadResellersLayoutSaga() {
    try {
        const params = {
            offset: 0,
            limit: 9999,
        };

        const result = yield getResellersApi(params);
        yield put(LayoutActions.loadResellersLayoutRes(result.data));
    } catch (e) {
        yield put(LayoutActions.loadResellersLayoutErr());
        console.log(e);
    }
}

export function* loadResellersLayoutWatcher() {
    yield takeLatest(LayoutTypes.LOAD_RESELLERS_LAYOUT, loadResellersLayoutSaga);
}
// L O A D   R E S E L L E R S

//  L O A D   F A V O R I S   O R D E R
export function* loadFavorisOrderSaga() {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const params = { filter: JSON.stringify({ order_number: layout.userData.data.favorite_orders }) };
        const resultOrder = yield getOrderApi(params);

        if (resultOrder.status === 200 && resultOrder.data.hits.length > 0) {
            let orders = resultOrder.data.hits;

            let customerIDS = [];

            orders.forEach((ord) => {
                customerIDS.push(ord.customer_id);
            });

            customerIDS = uniq(customerIDS);

            const customerParams = {
                filter: JSON.stringify({ _id: customerIDS }),
                joins: JSON.stringify(['main_contact']),
            };

            const constumerResult = yield getCustomersApi(customerParams);

            if (constumerResult.status === 200) {
                const customers = constumerResult.data.hits;

                orders = orders.map(order => ({
                    ...order, customer: customers.find(c => c._id === order.customer_id),
                }));
            }

            yield put(LayoutActions.loadFavorisOrderRes(orders));
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'order.notification.addFavorisOrderError', {}, { placement: 'bottomRight' });
        yield put(LayoutActions.loadFavorisOrderErr());
        console.log(e);
    }
}

export function* loadFavorisOrderWatcher() {
    yield takeLatest(LayoutTypes.LOAD_FAVORIS_ORDER, loadFavorisOrderSaga);
}
//  L O A D   F A V O R I S   O R D E R

// G E T   U S E R   D A T A
function* getUserDataSaga(action) {
    const { locale, admin } = yield select(getLayout);
    try {
        const headers = {
            Authorization: `${action.data.token_type} ${action.data.access_token}`,
            'Content-Type': 'application/json',
        };

        const result = yield LayoutApi.userDataApi({}, headers);

        if (result.status === 200) {
            const userData = yield result.data;
            yield put(LayoutActions.userLoginRes(action.data));
            yield put(LayoutActions.getUserDataRes(userData));

            const [userPermissions] = userData.user_group;
            const formsRoles = getAccess(userPermissions, 'forms');

            // yield call(loadFavorisOrderSaga, {});

            const { search } = window.location;
            if (userData.user_group[0].name.toLowerCase() === 'operator') {
                yield put(LayoutActions.setOperatorMachine({ machine: null }));
            } else {
                yield put(LayoutActions.setOperatorMachine(null));

                if (search !== '') {
                    const goto = queryString.parse(search.replace('?', ''));

                    if ('referer' in goto) {
                        if (goto.referer === '/401') {
                            yield put(push(CONFIG[admin].defaultRedirection));
                        } else {
                            yield put(push(goto.referer));
                        }
                    } else if (formsRoles.includes('read') && admin === 'mercuryflooring') {
                        yield put(push(CONFIG[admin].defaultOperator));
                    } else {
                        yield put(push(CONFIG[admin].defaultRedirection));
                    }
                } else if (formsRoles.includes('read') && admin === 'mercuryflooring') {
                    yield put(push(CONFIG[admin].defaultOperator));
                } else {
                    yield put(push(CONFIG[admin].defaultRedirection));
                }
            }

            setNotification('success', locale, 'global.hello.name', 'profile.login.loginSuccess', { username: userData.first_name });
        } else if (result.status === 401) {
            setNotification('error', locale, 'global.error', 'profile.login.loginError');
            yield put(LayoutActions.getUserDataErr());
        } else if (result.status === 500) {
            setNotification('error', locale, 'global.error', 'error.login.error');
            yield put(LayoutActions.getUserDataErr());
        } else {
            setNotification('error', locale, 'global.error', 'error.login.error');
            yield put(LayoutActions.getUserDataErr());
        }
    } catch (e) {
        yield put(LayoutActions.getUserDataErr());
        setNotification('error', locale, 'global.error', 'error.login.error');
        console.log(e);
    }
}

export function* getUserDataWatcher() {
    yield takeLatest(LayoutTypes.GET_USER_DATA, getUserDataSaga);
}
// G E T   U S E R   D A T A

// U S E R   L O G I N
function* userLoginSaga(action) {
    const { locale, reseller } = yield select(getLayout);

    const headers = {
        Authorization: '',
        'Content-Type': 'application/json',
    };

    try {
        const payload = action;

        payload.data.username.reseller_id = reseller ? reseller.data.hits[0].id : '';
        payload.data.username = JSON.stringify(payload.data.username);

        const result = yield LayoutApi.userLoginApi(payload.data, headers);

        if (result.status === 200) {
            const data = yield result.json();

            data.expirationDate = moment().add(data.expires_in * 1000).toISOString();

            yield call(getUserDataSaga, { data });
            yield call(loadPartnersLayoutSaga, {});
            yield call(loadResellersLayoutSaga, {});
        } else if (result.status === 401) {
            setNotification('error', locale, 'global.error', 'profile.login.loginError');
            yield put(LayoutActions.userLoginErr());
        } else {
            setNotification('error', locale, 'global.error', 'error.login.error');
            yield put(LayoutActions.userLoginErr());
        }
    } catch (e) {
        yield put(LayoutActions.userLoginErr());
        setNotification('error', locale, 'global.error', 'error.login.error');
        console.log(e);
    }
}

export function* userLoginWatcher() {
    yield takeLatest(LayoutTypes.USER_LOGIN, userLoginSaga);
}
// U S E R   L O G I N


// U S E R   L O G O U T
function* userLogoutSaga(action) {
    const { locale, userData } = yield select(getLayout);

    try {
        yield LayoutApi.userLogoutApi({});
        yield put(LayoutActions.userLogoutRes());

        yield put(resetFormVersionsFilters());
        yield put(resetJobFilters());

        yield delay(1000);

        if (action.event === 'expired') {
            setNotification('info', locale, 'global.goodbye.name', 'global.sessionExpired', { username: userData.data.first_name });
        } else {
            setNotification('info', locale, 'global.goodbye.name', 'global.sessionDisconnected', { username: userData.data.first_name });
        }

        yield put(push(`/${window.location.search}`));
    } catch (e) {
        console.log(e);
        yield put(LayoutActions.userLogoutErr());

        if (action.event === 'expired') {
            setNotification('info', locale, 'global.goodbye.name', 'global.sessionExpired', { username: userData.data.first_name });
        }
    }
}

export function* userLogoutWatcher() {
    yield takeLatest(LayoutTypes.USER_LOGOUT, userLogoutSaga);
}
// U S E R   L O G O U T
